import React, { Component } from 'react';
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import { OverPack }  from 'rc-scroll-anim';
import QueueAnim from 'rc-queue-anim';

function Part02(props) {
    const { t, i18n  } = useTranslation('base');
    const n = t('park_name'); //<b></b>;
    
  document.USE = props.pageTxtBlock;
  if (!props.pageArea) return null;
  return (
      <OverPack className="sezDesc" style={{backgroundImage:'url("' + process.env.PUBLIC_URL + '/img/descBG.jpg")'}}>
        <QueueAnim key="0" animation={{ opacity: 1 }} 
          xxtype='left'
          xxinterval='200'
          xduration='700'
          xxease="easeInOutQuart"
          >
           <>{parse(props.pageArea.txt)}</> 
          </QueueAnim>
      </OverPack>
    );
  }

export default Part02;

/*
      <section className="sezDesc" >
          <div>
            {parse(props.pageArea.txt)}
          </div>  
          <div>img</div>
        </section>
*/